module.exports = __webpack_public_path__ + "img/guideOne.5be8acc4.png";